import { useState } from "react";
import useLogin from "../../customHooks/useLogin";

import { IoEye, IoEyeOff } from "react-icons/io5";
import { LineWave } from "react-loader-spinner";
import almatin_img from "../../img/almatin_group.png";

import "./login.scss";


function Login() {
  const { handleLogin, loading, errorMessage } = useLogin();

  //===State start here===
  const [jobId, setJobId] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  //===State end here===

  //===Event handler start here===

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handelChenkbox = () => {
    setRememberMe((prev) => !prev);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLogin(jobId, password, rememberMe);
  };

  //===Event handler end here===

  const isButtonDisabled = !jobId || !password;

  return (
    <form onSubmit={handleSubmit}>
      <div className="login">
        <div className="login_header">
          <span>تسجيل الدخول</span>
        </div>
        <div className="login_container">
          <img
            src={almatin_img}
            alt="an image about al matin"
            className="img_login"
          />

          {errorMessage ? (
            <span className="login_page_errorMessage">{errorMessage}</span>
          ) : (
            <></>
          )}

          <div className="login_input_container">
            <div className="login_input">
              <input
                type="text"
                className="input_field_login"
                dir="rtl"
                value={jobId}
                onChange={(e) => setJobId(e.target.value)}
              />
              <label htmlFor="">الرقم الوظيفي</label>
            </div>

            <div className="login_input">
              {showPassword ? (
                <IoEyeOff onClick={(e) => handleClickShowPassword(e)} />
              ) : (
                <IoEye onClick={(e) => handleClickShowPassword(e)} />
              )}

              <input
                type={showPassword ? "text" : "password"}
                className="input_field_login input_field_login_password"
                dir="rtl"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <label htmlFor="">كلمة المرور</label>
            </div>

            <div className="login_input_btn_container">
              {loading ? (
                <LineWave
                  visible={true}
                  height="15rem"
                  width="15rem"
                  color="#4fa94d"
                  ariaLabel="line-wave-loading"
                  wrapperStyle={{}}
                  wrapperClass="live_btn_wave"
                  firstLineColor=""
                  middleLineColor=""
                  lastLineColor=""
                />
              ) : (
                <button
                  className={
                    isButtonDisabled || loading
                      ? "btn_for_login btn_for_login_disabled"
                      : "btn_for_login"
                  }
                  type="submit"
                  disabled={isButtonDisabled || loading}
                >
                  تسجيل الدخول
                </button>
              )}

              <div className="login_input_checkbox">
                <label htmlFor="">تذكرني</label>
                <input type="checkbox" onClick={(e) => handelChenkbox(e)} />
              </div>
            </div>
          </div>
        </div>

        <div className="login_footer">
          <div className="text_footer" dir="rtl">
            <div className="login_text_footer_name_section" dir="rtl">
              <span dir="rtl">
                تصميم و برمجة م. صالح الحايك و م. أنس المحي الدين{" "}
              </span>
              <span dir="rtl">من قسم التقانة لمجموعة المتين</span>
            </div>

            <span>
              <a href="#">Almatin.com</a>&copy; 2024
            </span>
          </div>
        </div>
      </div>
    </form>
  );
}

export default Login;
